<template>
  <div>
    <el-form ref="formRef" :model="signForm" label-width="120px">
      <el-form-item label="包名：">
        <el-input type="text" v-model="signForm.packageName" style="width:25em;" placeholder="请输入包名"></el-input>
      </el-form-item>
      <el-form-item label="短信模板ID：">
        <el-input type="text" v-model="signForm.templateId" style="width:25em;" placeholder="请输入短信模板ID"></el-input>
      </el-form-item>
      <el-form-item label="签名备注：">
        <el-input type="textarea" v-model="signForm.remark" style="width:25em;" placeholder="内部用于备注，与短信内容无关"></el-input>
      </el-form-item>
      <el-form-item label="短信类型：">
        <el-select v-model="type" placeholder="请选择" style="width: 8em;" disabled>
          <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {addOrUpdateSubmailConfig} from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      signForm: this.value.signForm,
      idx: this.value.ids,
      loading: false,

      // 短信来源
      typeArray: [
        {label: '验证码',value: 1}
      ],
      type: this.value.signForm.type?this.value.signForm.type:1,

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.signForm.packageName) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '包名不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.signForm.templateId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '短信模板ID不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let _this = this
      let param = {};
      param['id'] = this.signForm.id?this.signForm.id:0;
      param['type'] = this.type;
      param['templateId'] = this.signForm.templateId;
      param['packageName'] = this.signForm.packageName;
      param['remark'] = this.signForm.remark;
      postFormData(addOrUpdateSubmailConfig, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          _this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          _this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        _this.loading = false
      }).catch(()=>{
        _this.loading = false
      })
    },

  },
  mounted() {
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
